import React, { useEffect } from 'react'
import { Table, Tooltip,Image } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { useDictModel } from '@/views/base/dict/dictModel'
import { formatNum, momentFormat } from '@/utils/utils'
import { ISCMAssetsClearDetail } from '../assetsClearTypes'
import { useAssetsClearModel } from '../assetsClearModel'
import { globalPrompt } from '@/components/message'
import useNavModel from '@/model/navModel'
import { useAssetsClearDetailsModel } from './details/assetsClearDetailsModel'
import { DictCodeEnmu } from '@/types/AppDictEnums'
import { useOrgModel } from '@/views/base/organization/orgModel'
import { getBaseImgLookUrl } from '@/utils/constants'

export function DataTable() {
    const { getTreeNodeName } = useDictModel(() => [])
    const { getSelectedDictOne } = useDictModel(() => [])
    const { dataSource, selectedRowKeys, pgCfg, loading, loadData, setSelectedRowKeys } = useAssetsClearModel()
    const { resetEditCatch } = useAssetsClearDetailsModel()
    const { addNav, findNav, selectNav, switchNavState } = useNavModel(() => [])
    const { getOrgTreeSelect } = useOrgModel(() => [])

    useEffect(() => {
        loadData()
    }, [])
    const onLook = (value) => {
        let supplierEditKey = '2-7-2'
        let isFindNav = findNav(supplierEditKey)
        if (!isFindNav) {
            addNav(supplierEditKey, { id: value.id, mode: 'look' })
        } else {
            globalPrompt('modal', {
                title: '供应商跳转详情',
                type: 'warning',
                text: '您还有供应商详情未保存，是否跳转',
                okText: '跳转未保存页',
                onOk: () => selectNav(isFindNav ? isFindNav.id : ''),
                cancelText: '打开新页签',
                onCancel: () => {
                    switchNavState(supplierEditKey, { id: value.id, mode: 'look' })
                },
            })
        }
    }
    const columns: ColumnsType<ISCMAssetsClearDetail> = [
        {
            title: '序号',
            width: 50,
            align: 'center',
            fixed: 'left',
            render: (t, r, i) => i + 1,
        },
        {
            title: '清理单号',
            width: 140,
            dataIndex: 'code',
            fixed: 'left',
            render: (t, r) => (
                <>
                    <span
                        style={{ color: '#4165E3', cursor: 'pointer' }}
                        onClick={() => {
                            onLook(r)
                        }}
                    >
                        {t}
                    </span>
                </>
            ),
        },
        {
            title: '凭证',
            width: 170,
            align: "center",
            fixed: 'left',
            render: (text, records) => (records.md5 ? <Image src={getBaseImgLookUrl(records.md5)}  style={{width:'120px',height:'40px'}}/> : null)
        },
        {
            title: '数量',
            width: 180,
            dataIndex: 'totalNum',
            // fixed: 'left',
        },
        {
            title: '清理人',
            width: 160,
            dataIndex: 'createUser',
        },
        {
            title: '清理日期',
            width: 160,
            dataIndex: 'createTime',
            render: (text) => `${momentFormat(text)}`,
        },
    ]

    //点击行选高亮
    const onRow = (id: string) => {
        let findIndex = selectedRowKeys.indexOf(id)
        let newSelectedRowKeys = [...selectedRowKeys]
        if (findIndex === -1) {
            newSelectedRowKeys.push(id)
            setSelectedRowKeys(newSelectedRowKeys)
        } else {
            newSelectedRowKeys.splice(findIndex, 1)
            setSelectedRowKeys(newSelectedRowKeys)
        }
    }

    return (
        <Table
            rowKey={(record) => record.id}
            loading={loading}
            rowSelection={{
                //全部选中时  (存string[])
                onSelectAll: (selected, selectedRows, changeRows) => {
                    let changeRowId = changeRows.map((item) => item.id)
                    selected
                        ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
                        : setSelectedRowKeys((origin) => origin.filter((item) => changeRowId.indexOf(item) < 0))
                },
                onSelect: (record) => onRow(record.id),
                selectedRowKeys: selectedRowKeys,
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ['bottomCenter'],
                showTotal: (total: number) => `共${total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                },
                showSizeChanger: true,
            }}
            bordered
            onRow={(record) => ({
                onClick: () => onRow(record.id),
                onContextMenu: (e) => {
                    e.preventDefault()
                    setSelectedRowKeys([record.id])
                },
            })}
            scroll={{ x: 'max-content', y: 'calc(100vh - 410px)' }}
        />
    )
}
